import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {API_URL} from '../../../constants';

import axios from 'axios';
import $ from 'jquery';

import Error from '../../Error/error';
import { Pagination } from '../../Elements/Pagination/tablePagination';

export default class ListarPagina extends Component {
    constructor(props) {
        super(props); 

        this.state = {
            pagina:     1,
            id:         this.props.match.params.id,
            loading:    true,
            data:       [],
            error:      [],
            roles:      [],
            response:   [],
            deleting:   false
        }

        this.getData = this.getData.bind(this);
    }

    getData (page = "") {
        if(document.querySelector('.loader').classList.contains('loader--hide')){
            document.querySelector('.loader').classList.remove('loader--hide');
            document.getElementById('content-wrapper').setAttribute("hidden", true);
        }

        if(page === ''){
            page = 1;
        }

        const url = `${API_URL}PaginaUX/${page}/${this.state.id}`;

        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            console.log(data);

            this.setState({ 
                data:       data.result, 
                response:   data, 
                error:      data.Error,
                pagina:     page,
                loading:    false
            });

            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");

        }).catch(error => {
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
        });
    }

    paginationTable(){
        var entity = this.state.data.length > 0 ? this.state.data[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            options.push(
                <a 
                    className="btnPrevPaginador" 
                    id={0} 
                    key={0} 
                    onClick={(e) => Number(this.state.pagina) <= 1 ? "" : this.getData(this.state.searchText, `${Number(this.state.pagina) - 1}`)}
                ></a>
            );
            
            for(let index = 1; index < entity.totalPages + 1; index++){

                options.push(
                    <a 
                        id={index} 
                        key={index} 
                        onClick={(e) => this.getData(this.state.searchText, `${index}`)}
                        className={(index.toString() === this.state.pagina.toString() ? "active" : "") + " pageItem"}
                    > 
                        {index} 
                    </a>
                );
            }

            options.push(
                <a 
                    className="btnNextPaginador" 
                    id={entity.totalPages+1} 
                    key={entity.totalPages+1} 
                    onClick={(e) => entity.totalPages.toString() === this.state.pagina.toString() ? "" : this.getData(this.state.searchText, `${Number(this.state.pagina) + 1}`)}
                ></a>
            );

            console.log(options);

            return (
                <div className="divPaginador" key={"pagination"} id="pagination">
                    {options}
                </div>
            );
        }
    }

    addPage(){
        this.props.history.push({
            pathname: `/asignar-pagina/usuario/${this.state.id}`,
            state: { key: this.state.id}
        });
    }

    deletePage(id){
        const url = `${API_URL}PaginaUX/EliminarPaginaUsuario/${this.state.id}/${id}`;

        this.setState({
            deleting: true
        })

        axios.put(url).then(response => response.data)
        .then((data) => {

            toast.success(`Página id ${id} eliminada correctamente`);
            this.getData(1);
            this.setState({
                deleting: false
            })

        }).catch(error => {
            // document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
            this.setState({
                deleting: false
            })
        });
    }

    componentDidMount(){
        this.getData(this.state.pagina);
    }

    render(){
        return (
            (this.state.response.statusCode == 200) ?
                <div>
                    <div id="detailBody" className="Site-content">
                        <div className="loader"></div>
                        <div hidden={true} id="content-wrapper">
                            <div id="content">
                                <div id="Body" className="body-container">

                                    <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt />
                                            <a  href="/">
                                                / Panel de configuración general
                                            </a >
                                            <Link to="/permisos">
                                                / Usuarios
                                            </Link>
                                            <Link to="/usuarios">
                                                / Lista de usuarios
                                            </Link>
                                            <span> / Páginas</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                        Páginas asignadas al usuario
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12 col-lg-10 mx-auto">

                                            <div className="divCatAnadir_Panel">
                                                <a 
                                                    href="#" 
                                                    className="btnAnadirCat noneEvent" 
                                                    onClick={() => this.addPage()} 
                                                >
                                                    AÑADIR
                                                </a>
                                                <div className="divSectorSearch_Panel d-none">
                                                    <input 
                                                        type="text" 
                                                        id="busqueda" 
                                                        placeholder="Encontrar página" 
                                                        // onChange={this.handleInputTextChange} 
                                                        name="search" 
                                                    />
                                                    <input 
                                                        type="submit" 
                                                        defaultValue="Buscar" 
                                                        // onClick={() => this.searchEvent()}  
                                                    />
                                                </div>
                                                <div className="clear" />
                                            </div>
                                            <div className="divTablaPage_Panel">
                                                <div className="table-responsive">
                                                    <table border={1} cellSpacing={0}>
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Título</th>
                                                                <th>Plantilla</th>

                                                        

                                                                <th>Creación</th>
                                                                <th>Desasignar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.length > 0 ? 
                                                                this.state.data.map((item) => (
                                                                    <tr>
                                                                        <td>{item.pagi_Id}</td>
                                                                        <td style={{ maxWidth: "250px" }}>
                                                                            {item.pagi_Titulo}
                                                                        </td>
                                                                        <td>{item.plantilla}</td>

                                                         

                                                                        <td>{moment(item.pagi_FechaCreacion).format("YYYY-DD-MM")}</td>
                                                                        <td>
                                                                            <button 
                                                                                disabled={this.state.deleting}
                                                                                className='btn btn-primary'
                                                                                onClick={() => this.deletePage(item.pagi_Id)}
                                                                            >
                                                                                <i className="fas fa-lock-open"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            :
                                                                <tr>
                                                                    <td colSpan={10}>
                                                                        Sin páginas asignadas para este usuario
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {this.state.data.length > 0 &&
                                                    <div>
                                                        <Pagination
                                                            data={this.state.data}
                                                            pagina={this.state.pagina}
                                                            changePage={(page) => this.getData(page)}
                                                        />
                                                    </div>
                                                }
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            :
            <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
        )
    }
}